export default [
      { name: '北京市', adcode: '110000', citycode: '010', city_code: 'bj' },
      { name: '天津市', adcode: '120000', citycode: '022', city_code: 'tj' },
      { name: '石家庄市', adcode: '130100', citycode: '0311', city_code: 'sjz' },
      { name: '唐山市', adcode: '130200', citycode: '0315', city_code: 'ts' },
      { name: '秦皇岛市', adcode: '130300', citycode: '0335', city_code: 'qhd' },
      { name: '邯郸市', adcode: '130400', citycode: '0310', city_code: 'hd' },
      { name: '邢台市', adcode: '130500', citycode: '0319', city_code: 'xt' },
      { name: '保定市', adcode: '130600', citycode: '0312', city_code: 'bd' },
      { name: '张家口市', adcode: '130700', citycode: '0313', city_code: 'zjk' },
      { name: '承德市', adcode: '130800', citycode: '0314', city_code: 'cd' },
      { name: '沧州市', adcode: '130900', citycode: '0317', city_code: 'cz' },
      { name: '廊坊市', adcode: '131000', citycode: '0316', city_code: 'lf' },
      { name: '衡水市', adcode: '131100', citycode: '0318', city_code: 'hs' },
      { name: '太原市', adcode: '140100', citycode: '0351', city_code: 'ty' },
      { name: '大同市', adcode: '140200', citycode: '0352', city_code: 'dt' },
      { name: '阳泉市', adcode: '140300', citycode: '0353', city_code: 'yq' },
      { name: '长治市', adcode: '140400', citycode: '0355', city_code: 'cz' },
      { name: '晋城市', adcode: '140500', citycode: '0356', city_code: 'jc' },
      { name: '朔州市', adcode: '140600', citycode: '0349', city_code: 'sz' },
      { name: '晋中市', adcode: '140700', citycode: '0354', city_code: 'jz' },
      { name: '运城市', adcode: '140800', citycode: '0359', city_code: 'yc' },
      { name: '忻州市', adcode: '140900', citycode: '0350', city_code: 'xz' },
      { name: '临汾市', adcode: '141000', citycode: '0357', city_code: 'lf' },
      { name: '吕梁市', adcode: '141100', citycode: '0358', city_code: 'll' },
      { name: '呼和浩特市', adcode: '150100', citycode: '0471', city_code: 'hhht' },
      { name: '包头市', adcode: '150200', citycode: '0472', city_code: 'bt' },
      { name: '乌海市', adcode: '150300', citycode: '0473', city_code: 'wh' },
      { name: '赤峰市', adcode: '150400', citycode: '0476', city_code: 'cf' },
      { name: '通辽市', adcode: '150500', citycode: '0475', city_code: 'tl' },
      { name: '鄂尔多斯市', adcode: '150600', citycode: '0477', city_code: 'eeds' },
      { name: '呼伦贝尔市', adcode: '150700', citycode: '0470', city_code: 'hlbe' },
      { name: '巴彦淖尔市', adcode: '150800', citycode: '0478', city_code: 'byne' },
      { name: '乌兰察布市', adcode: '150900', citycode: '0474', city_code: 'wlcb' },
      { name: '兴安盟', adcode: '152200', citycode: '0482', city_code: 'xam' },
      { name: '锡林郭勒盟', adcode: '152500', citycode: '0479', city_code: 'xlglm' },
      { name: '阿拉善盟', adcode: '152900', citycode: '0483', city_code: 'alsm' },
      { name: '沈阳市', adcode: '210100', citycode: '024', city_code: 'sy' },
      { name: '大连市', adcode: '210200', citycode: '0411', city_code: 'dl' },
      { name: '鞍山市', adcode: '210300', citycode: '0412', city_code: 'as' },
      { name: '抚顺市', adcode: '210400', citycode: '0413', city_code: 'fs' },
      { name: '本溪市', adcode: '210500', citycode: '0414', city_code: 'bx' },
      { name: '丹东市', adcode: '210600', citycode: '0415', city_code: 'dd' },
      { name: '锦州市', adcode: '210700', citycode: '0416', city_code: 'jz' },
      { name: '营口市', adcode: '210800', citycode: '0417', city_code: 'yk' },
      { name: '阜新市', adcode: '210900', citycode: '0418', city_code: 'fx' },
      { name: '辽阳市', adcode: '211000', citycode: '0419', city_code: 'ly' },
      { name: '盘锦市', adcode: '211100', citycode: '0427', city_code: 'pj' },
      { name: '铁岭市', adcode: '211200', citycode: '0410', city_code: 'tl' },
      { name: '朝阳市', adcode: '211300', citycode: '0421', city_code: 'cy' },
      { name: '葫芦岛市', adcode: '211400', citycode: '0429', city_code: 'hld' },
      { name: '长春市', adcode: '220100', citycode: '0431', city_code: 'cc' },
      { name: '吉林市', adcode: '220200', citycode: '0432', city_code: 'jl' },
      { name: '四平市', adcode: '220300', citycode: '0434', city_code: 'sp' },
      { name: '辽源市', adcode: '220400', citycode: '0437', city_code: 'ly' },
      { name: '通化市', adcode: '220500', citycode: '0435', city_code: 'th' },
      { name: '白山市', adcode: '220600', citycode: '0439', city_code: 'bs' },
      { name: '松原市', adcode: '220700', citycode: '0438', city_code: 'sy' },
      { name: '白城市', adcode: '220800', citycode: '0436', city_code: 'bc' },
      { name: '延边朝鲜族自治州', adcode: '222400', citycode: '1433', city_code: 'yb' },
      { name: '哈尔滨市', adcode: '230100', citycode: '0451', city_code: 'heb' },
      { name: '齐齐哈尔市', adcode: '230200', citycode: '0452', city_code: 'qqhe' },
      { name: '鸡西市', adcode: '230300', citycode: '0467', city_code: 'jx' },
      { name: '鹤岗市', adcode: '230400', citycode: '0468', city_code: 'hg' },
      { name: '双鸭山市', adcode: '230500', citycode: '0469', city_code: 'sys' },
      { name: '大庆市', adcode: '230600', citycode: '0459', city_code: 'dq' },
      { name: '伊春市', adcode: '230700', citycode: '0458', city_code: 'yc' },
      { name: '佳木斯市', adcode: '230800', citycode: '0454', city_code: 'jms' },
      { name: '七台河市', adcode: '230900', citycode: '0464', city_code: 'qth' },
      { name: '牡丹江市', adcode: '231000', citycode: '0453', city_code: 'mdj' },
      { name: '黑河市', adcode: '231100', citycode: '0456', city_code: 'hh' },
      { name: '绥化市', adcode: '231200', citycode: '0455', city_code: 'sh' },
      { name: '大兴安岭地区', adcode: '232700', citycode: '0457', city_code: 'dxal' },
      { name: '上海市', adcode: '310000', citycode: '021', city_code: 'sh' },
      { name: '南京市', adcode: '320100', citycode: '025', city_code: 'nj' },
      { name: '无锡市', adcode: '320200', citycode: '0510', city_code: 'wx' },
      { name: '徐州市', adcode: '320300', citycode: '0516', city_code: 'xz' },
      { name: '常州市', adcode: '320400', citycode: '0519', city_code: 'cz' },
      { name: '苏州市', adcode: '320500', citycode: '0512', city_code: 'sz' },
      { name: '南通市', adcode: '320600', citycode: '0513', city_code: 'nt' },
      { name: '连云港市', adcode: '320700', citycode: '0518', city_code: 'lyg' },
      { name: '淮安市', adcode: '320800', citycode: '0517', city_code: 'ha' },
      { name: '盐城市', adcode: '320900', citycode: '0515', city_code: 'yc' },
      { name: '扬州市', adcode: '321000', citycode: '0514', city_code: 'yz' },
      { name: '镇江市', adcode: '321100', citycode: '0511', city_code: 'zj' },
      { name: '泰州市', adcode: '321200', citycode: '0523', city_code: 'tz' },
      { name: '宿迁市', adcode: '321300', citycode: '0527', city_code: 'sq' },
      { name: '杭州市', adcode: '330100', citycode: '0571', city_code: 'hz' },
      { name: '宁波市', adcode: '330200', citycode: '0574', city_code: 'nb' },
      { name: '温州市', adcode: '330300', citycode: '0577', city_code: 'wz' },
      { name: '嘉兴市', adcode: '330400', citycode: '0573', city_code: 'jx' },
      { name: '海宁市', adcode: '330481', citycode: '0573', city_code: 'haining' },
      { name: '湖州市', adcode: '330500', citycode: '0572', city_code: 'hz' },
      { name: '绍兴市', adcode: '330600', citycode: '0575', city_code: 'sx' },
      { name: '金华市', adcode: '330700', citycode: '0579', city_code: 'jh' },
      { name: '衢州市', adcode: '330800', citycode: '0570', city_code: 'qz' },
      { name: '舟山市', adcode: '330900', citycode: '0580', city_code: 'zs' },
      { name: '台州市', adcode: '331000', citycode: '0576', city_code: 'tz' },
      { name: '丽水市', adcode: '331100', citycode: '0578', city_code: 'ls' },
      { name: '合肥市', adcode: '340100', citycode: '0551', city_code: 'hf' },
      { name: '芜湖市', adcode: '340200', citycode: '0553', city_code: 'wh' },
      { name: '蚌埠市', adcode: '340300', citycode: '0552', city_code: 'bb' },
      { name: '淮南市', adcode: '340400', citycode: '0554', city_code: 'hn' },
      { name: '马鞍山市', adcode: '340500', citycode: '0555', city_code: 'mas' },
      { name: '淮北市', adcode: '340600', citycode: '0561', city_code: 'hb' },
      { name: '铜陵市', adcode: '340700', citycode: '0562', city_code: 'tl' },
      { name: '安庆市', adcode: '340800', citycode: '0556', city_code: 'aq' },
      { name: '黄山市', adcode: '341000', citycode: '0559', city_code: 'hs' },
      { name: '滁州市', adcode: '341100', citycode: '0550', city_code: 'cz' },
      { name: '阜阳市', adcode: '341200', citycode: '1558', city_code: 'fy' },
      { name: '宿州市', adcode: '341300', citycode: '0557', city_code: 'sz' },
      { name: '六安市', adcode: '341500', citycode: '0564', city_code: 'la' },
      { name: '亳州市', adcode: '341600', citycode: '0558', city_code: 'bz' },
      { name: '池州市', adcode: '341700', citycode: '0566', city_code: 'cz' },
      { name: '宣城市', adcode: '341800', citycode: '0563', city_code: 'xc' },
      { name: '福州市', adcode: '350100', citycode: '0591', city_code: 'fz' },
      { name: '厦门市', adcode: '350200', citycode: '0592', city_code: 'xm' },
      { name: '莆田市', adcode: '350300', citycode: '0594', city_code: 'pt' },
      { name: '三明市', adcode: '350400', citycode: '0598', city_code: 'sm' },
      { name: '泉州市', adcode: '350500', citycode: '0595', city_code: 'qz' },
      { name: '漳州市', adcode: '350600', citycode: '0596', city_code: 'zz' },
      { name: '南平市', adcode: '350700', citycode: '0599', city_code: 'np' },
      { name: '龙岩市', adcode: '350800', citycode: '0597', city_code: 'ly' },
      { name: '宁德市', adcode: '350900', citycode: '0593', city_code: 'nd' },
      { name: '南昌市', adcode: '360100', citycode: '0791', city_code: 'nc' },
      { name: '景德镇市', adcode: '360200', citycode: '0798', city_code: 'jdz' },
      { name: '萍乡市', adcode: '360300', citycode: '0799', city_code: 'px' },
      { name: '九江市', adcode: '360400', citycode: '0792', city_code: 'jj' },
      { name: '新余市', adcode: '360500', citycode: '0790', city_code: 'xy' },
      { name: '鹰潭市', adcode: '360600', citycode: '0701', city_code: 'yt' },
      { name: '赣州市', adcode: '360700', citycode: '0797', city_code: 'gz' },
      { name: '吉安市', adcode: '360800', citycode: '0796', city_code: 'ja' },
      { name: '宜春市', adcode: '360900', citycode: '0795', city_code: 'yc' },
      { name: '抚州市', adcode: '361000', citycode: '0794', city_code: 'fz' },
      { name: '上饶市', adcode: '361100', citycode: '0793', city_code: 'sr' },
      { name: '济南市', adcode: '370100', citycode: '0531', city_code: 'jn' },
      { name: '青岛市', adcode: '370200', citycode: '0532', city_code: 'qd' },
      { name: '淄博市', adcode: '370300', citycode: '0533', city_code: 'zb' },
      { name: '枣庄市', adcode: '370400', citycode: '0632', city_code: 'zz' },
      { name: '东营市', adcode: '370500', citycode: '0546', city_code: 'dy' },
      { name: '烟台市', adcode: '370600', citycode: '0535', city_code: 'yt' },
      { name: '潍坊市', adcode: '370700', citycode: '0536', city_code: 'wf' },
      { name: '济宁市', adcode: '370800', citycode: '0537', city_code: 'jn' },
      { name: '泰安市', adcode: '370900', citycode: '0538', city_code: 'ta' },
      { name: '威海市', adcode: '371000', citycode: '0631', city_code: 'wh' },
      { name: '日照市', adcode: '371100', citycode: '0633', city_code: 'rz' },
      { name: '临沂市', adcode: '371300', citycode: '0539', city_code: 'ly' },
      { name: '德州市', adcode: '371400', citycode: '0534', city_code: 'dz' },
      { name: '聊城市', adcode: '371500', citycode: '0635', city_code: 'lc' },
      { name: '滨州市', adcode: '371600', citycode: '0543', city_code: 'bz' },
      { name: '菏泽市', adcode: '371700', citycode: '0530', city_code: 'hz' },
      { name: '郑州市', adcode: '410100', citycode: '0371', city_code: 'zz' },
      { name: '开封市', adcode: '410200', citycode: '0378', city_code: 'kf' },
      { name: '洛阳市', adcode: '410300', citycode: '0379', city_code: 'ly' },
      { name: '平顶山市', adcode: '410400', citycode: '0375', city_code: 'pds' },
      { name: '安阳市', adcode: '410500', citycode: '0372', city_code: 'ay' },
      { name: '鹤壁市', adcode: '410600', citycode: '0392', city_code: 'hb' },
      { name: '新乡市', adcode: '410700', citycode: '0373', city_code: 'xx' },
      { name: '焦作市', adcode: '410800', citycode: '0391', city_code: 'jz' },
      { name: '濮阳市', adcode: '410900', citycode: '0393', city_code: 'py' },
      { name: '许昌市', adcode: '411000', citycode: '0374', city_code: 'xc' },
      { name: '漯河市', adcode: '411100', citycode: '0395', city_code: 'lh' },
      { name: '三门峡市', adcode: '411200', citycode: '0398', city_code: 'smx' },
      { name: '南阳市', adcode: '411300', citycode: '0377', city_code: 'ny' },
      { name: '商丘市', adcode: '411400', citycode: '0370', city_code: 'sq' },
      { name: '信阳市', adcode: '411500', citycode: '0376', city_code: 'xy' },
      { name: '周口市', adcode: '411600', citycode: '0394', city_code: 'zk' },
      { name: '驻马店市', adcode: '411700', citycode: '0396', city_code: 'zmd' },
      { name: '济源市', adcode: '419001', citycode: '1391', city_code: 'jy' },
      { name: '武汉市', adcode: '420100', citycode: '027', city_code: 'wh' },
      { name: '黄石市', adcode: '420200', citycode: '0714', city_code: 'hs' },
      { name: '十堰市', adcode: '420300', citycode: '0719', city_code: 'sy' },
      { name: '宜昌市', adcode: '420500', citycode: '0717', city_code: 'yc' },
      { name: '襄阳市', adcode: '420600', citycode: '0710', city_code: 'xy' },
      { name: '鄂州市', adcode: '420700', citycode: '0711', city_code: 'ez' },
      { name: '荆门市', adcode: '420800', citycode: '0724', city_code: 'jm' },
      { name: '孝感市', adcode: '420900', citycode: '0712', city_code: 'xg' },
      { name: '荆州市', adcode: '421000', citycode: '0716', city_code: 'jz' },
      { name: '黄冈市', adcode: '421100', citycode: '0713', city_code: 'hg' },
      { name: '咸宁市', adcode: '421200', citycode: '0715', city_code: 'xn' },
      { name: '随州市', adcode: '421300', citycode: '0722', city_code: 'sz' },
      { name: '恩施土家族苗族自治州', adcode: '422800', citycode: '0718', city_code: 'es' },
      { name: '仙桃市', adcode: '429004', citycode: '0728', city_code: 'xt' },
      { name: '潜江市', adcode: '429005', citycode: '2728', city_code: 'qj' },
      { name: '天门市', adcode: '429006', citycode: '1728', city_code: 'tm' },
      { name: '神农架林区', adcode: '429021', citycode: '1719', city_code: 'snj' },
      { name: '长沙市', adcode: '430100', citycode: '0731', city_code: 'cs' },
      { name: '株洲市', adcode: '430200', citycode: '0733', city_code: 'zz' },
      { name: '湘潭市', adcode: '430300', citycode: '0732', city_code: 'xt' },
      { name: '衡阳市', adcode: '430400', citycode: '0734', city_code: 'hy' },
      { name: '邵阳市', adcode: '430500', citycode: '0739', city_code: 'sy' },
      { name: '岳阳市', adcode: '430600', citycode: '0730', city_code: 'yy' },
      { name: '常德市', adcode: '430700', citycode: '0736', city_code: 'cd' },
      { name: '张家界市', adcode: '430800', citycode: '0744', city_code: 'zjj' },
      { name: '益阳市', adcode: '430900', citycode: '0737', city_code: 'yy' },
      { name: '郴州市', adcode: '431000', citycode: '0735', city_code: 'cz' },
      { name: '永州市', adcode: '431100', citycode: '0746', city_code: 'yz' },
      { name: '怀化市', adcode: '431200', citycode: '0745', city_code: 'hh' },
      { name: '娄底市', adcode: '431300', citycode: '0738', city_code: 'ld' },
      { name: '湘西土家族苗族自治州', adcode: '433100', citycode: '0743', city_code: 'xx' },
      { name: '广州市', adcode: '440100', citycode: '020', city_code: 'gz' },
      { name: '韶关市', adcode: '440200', citycode: '0751', city_code: 'sg' },
      { name: '深圳市', adcode: '440300', citycode: '0755', city_code: 'sz' },
      { name: '珠海市', adcode: '440400', citycode: '0756', city_code: 'zh' },
      { name: '汕头市', adcode: '440500', citycode: '0754', city_code: 'st' },
      { name: '佛山市', adcode: '440600', citycode: '0757', city_code: 'fs' },
      { name: '江门市', adcode: '440700', citycode: '0750', city_code: 'jm' },
      { name: '湛江市', adcode: '440800', citycode: '0759', city_code: 'zj' },
      { name: '茂名市', adcode: '440900', citycode: '0668', city_code: 'mm' },
      { name: '肇庆市', adcode: '441200', citycode: '0758', city_code: 'zq' },
      { name: '惠州市', adcode: '441300', citycode: '0752', city_code: 'hz' },
      { name: '梅州市', adcode: '441400', citycode: '0753', city_code: 'mz' },
      { name: '汕尾市', adcode: '441500', citycode: '0660', city_code: 'sw' },
      { name: '河源市', adcode: '441600', citycode: '0762', city_code: 'hy' },
      { name: '阳江市', adcode: '441700', citycode: '0662', city_code: 'yj' },
      { name: '清远市', adcode: '441800', citycode: '0763', city_code: 'qy' },
      { name: '东莞市', adcode: '441900', citycode: '0769', city_code: 'dg' },
      { name: '中山市', adcode: '442000', citycode: '0760', city_code: 'zs' },
      { name: '潮州市', adcode: '445100', citycode: '0768', city_code: 'cz' },
      { name: '揭阳市', adcode: '445200', citycode: '0663', city_code: 'jy' },
      { name: '云浮市', adcode: '445300', citycode: '0766', city_code: 'yf' },
      { name: '南宁市', adcode: '450100', citycode: '0771', city_code: 'nn' },
      { name: '柳州市', adcode: '450200', citycode: '0772', city_code: 'lz' },
      { name: '桂林市', adcode: '450300', citycode: '0773', city_code: 'gl' },
      { name: '梧州市', adcode: '450400', citycode: '0774', city_code: 'wz' },
      { name: '北海市', adcode: '450500', citycode: '0779', city_code: 'bh' },
      { name: '防城港市', adcode: '450600', citycode: '0770', city_code: 'fcg' },
      { name: '钦州市', adcode: '450700', citycode: '0777', city_code: 'qz' },
      { name: '贵港市', adcode: '450800', citycode: '1755', city_code: 'gg' },
      { name: '玉林市', adcode: '450900', citycode: '0775', city_code: 'yl' },
      { name: '百色市', adcode: '451000', citycode: '0776', city_code: 'bs' },
      { name: '贺州市', adcode: '451100', citycode: '1774', city_code: 'hz' },
      { name: '河池市', adcode: '451200', citycode: '0778', city_code: 'hc' },
      { name: '来宾市', adcode: '451300', citycode: '1772', city_code: 'lb' },
      { name: '崇左市', adcode: '451400', citycode: '1771', city_code: 'cz' },
      { name: '海口市', adcode: '460100', citycode: '0898', city_code: 'hk' },
      { name: '三亚市', adcode: '460200', citycode: '0899', city_code: 'sy' },
      { name: '三沙市', adcode: '460300', citycode: '2898', city_code: 'ss' },
      { name: '儋州市', adcode: '460400', citycode: '0805', city_code: 'dz' },
      { name: '五指山市', adcode: '469001', citycode: '1897', city_code: 'wzs' },
      { name: '琼海市', adcode: '469002', citycode: '1894', city_code: 'qh' },
      { name: '文昌市', adcode: '469005', citycode: '1893', city_code: 'wc' },
      { name: '万宁市', adcode: '469006', citycode: '1898', city_code: 'wn' },
      { name: '东方市', adcode: '469007', citycode: '0807', city_code: 'df' },
      { name: '定安县', adcode: '469021', citycode: '0806', city_code: 'da' },
      { name: '屯昌县', adcode: '469022', citycode: '1892', city_code: 'tc' },
      { name: '澄迈县', adcode: '469023', citycode: '0804', city_code: 'cm' },
      { name: '临高县', adcode: '469024', citycode: '1896', city_code: 'lg' },
      { name: '白沙黎族自治县', adcode: '469025', citycode: '0802', city_code: 'bs' },
      { name: '昌江黎族自治县', adcode: '469026', citycode: '0803', city_code: 'cj' },
      { name: '乐东黎族自治县', adcode: '469027', citycode: '2802', city_code: 'ld' },
      { name: '陵水黎族自治县', adcode: '469028', citycode: '0809', city_code: 'ls' },
      { name: '保亭黎族苗族自治县', adcode: '469029', citycode: '0801', city_code: 'bt' },
      { name: '琼中黎族苗族自治县', adcode: '469030', citycode: '1899', city_code: 'qz' },
      { name: '重庆市', adcode: '500000', citycode: '023', city_code: 'cq' },
      { name: '成都市', adcode: '510100', citycode: '028', city_code: 'cd' },
      { name: '自贡市', adcode: '510300', citycode: '0813', city_code: 'zg' },
      { name: '攀枝花市', adcode: '510400', citycode: '0812', city_code: 'pzh' },
      { name: '泸州市', adcode: '510500', citycode: '0830', city_code: 'lz' },
      { name: '德阳市', adcode: '510600', citycode: '0838', city_code: 'dy' },
      { name: '绵阳市', adcode: '510700', citycode: '0816', city_code: 'my' },
      { name: '广元市', adcode: '510800', citycode: '0839', city_code: 'gy' },
      { name: '遂宁市', adcode: '510900', citycode: '0825', city_code: 'sn' },
      { name: '内江市', adcode: '511000', citycode: '1832', city_code: 'nj' },
      { name: '乐山市', adcode: '511100', citycode: '0833', city_code: 'ls' },
      { name: '南充市', adcode: '511300', citycode: '0817', city_code: 'nc' },
      { name: '眉山市', adcode: '511400', citycode: '1833', city_code: 'ms' },
      { name: '宜宾市', adcode: '511500', citycode: '0831', city_code: 'yb' },
      { name: '广安市', adcode: '511600', citycode: '0826', city_code: 'ga' },
      { name: '达州市', adcode: '511700', citycode: '0818', city_code: 'dz' },
      { name: '雅安市', adcode: '511800', citycode: '0835', city_code: 'ya' },
      { name: '巴中市', adcode: '511900', citycode: '0827', city_code: 'bz' },
      { name: '资阳市', adcode: '512000', citycode: '0832', city_code: 'zy' },
      { name: '阿坝藏族羌族自治州', adcode: '513200', citycode: '0837', city_code: 'ab' },
      { name: '甘孜藏族自治州', adcode: '513300', citycode: '0836', city_code: 'gz' },
      { name: '凉山彝族自治州', adcode: '513400', citycode: '0834', city_code: 'ls' },
      { name: '贵阳市', adcode: '520100', citycode: '0851', city_code: 'gy' },
      { name: '六盘水市', adcode: '520200', citycode: '0858', city_code: 'lps' },
      { name: '遵义市', adcode: '520300', citycode: '0852', city_code: 'zy' },
      { name: '安顺市', adcode: '520400', citycode: '0853', city_code: 'as' },
      { name: '毕节市', adcode: '520500', citycode: '0857', city_code: 'bj' },
      { name: '铜仁市', adcode: '520600', citycode: '0856', city_code: 'tr' },
      { name: '黔西南布依族苗族自治州', adcode: '522300', citycode: '0859', city_code: 'qxn' },
      { name: '黔东南苗族侗族自治州', adcode: '522600', citycode: '0855', city_code: 'qdn' },
      { name: '黔南布依族苗族自治州', adcode: '522700', citycode: '0854', city_code: 'qn' },
      { name: '昆明市', adcode: '530100', citycode: '0871', city_code: 'km' },
      { name: '曲靖市', adcode: '530300', citycode: '0874', city_code: 'qj' },
      { name: '玉溪市', adcode: '530400', citycode: '0877', city_code: 'yx' },
      { name: '保山市', adcode: '530500', citycode: '0875', city_code: 'bs' },
      { name: '昭通市', adcode: '530600', citycode: '0870', city_code: 'zt' },
      { name: '丽江市', adcode: '530700', citycode: '0888', city_code: 'lj' },
      { name: '普洱市', adcode: '530800', citycode: '0879', city_code: 'pe' },
      { name: '临沧市', adcode: '530900', citycode: '0883', city_code: 'lc' },
      { name: '楚雄彝族自治州', adcode: '532300', citycode: '0878', city_code: 'cx' },
      { name: '红河哈尼族彝族自治州', adcode: '532500', citycode: '0873', city_code: 'hh' },
      { name: '文山壮族苗族自治州', adcode: '532600', citycode: '0876', city_code: 'ws' },
      { name: '西双版纳傣族自治州', adcode: '532800', citycode: '0691', city_code: 'xsbn' },
      { name: '大理白族自治州', adcode: '532900', citycode: '0872', city_code: 'dl' },
      { name: '德宏傣族景颇族自治州', adcode: '533100', citycode: '0692', city_code: 'dh' },
      { name: '怒江傈僳族自治州', adcode: '533300', citycode: '0886', city_code: 'nj' },
      { name: '迪庆藏族自治州', adcode: '533400', citycode: '0887', city_code: 'dq' },
      { name: '拉萨市', adcode: '540100', citycode: '0891', city_code: 'ls' },
      { name: '日喀则市', adcode: '540200', citycode: '0892', city_code: 'rkz' },
      { name: '昌都市', adcode: '540300', citycode: '0895', city_code: 'cd' },
      { name: '林芝市', adcode: '540400', citycode: '0894', city_code: 'lz' },
      { name: '山南市', adcode: '540500', citycode: '0893', city_code: 'sn' },
      { name: '那曲市', adcode: '540600', citycode: '0896', city_code: 'nq' },
      { name: '阿里地区', adcode: '542500', citycode: '0897', city_code: 'al' },
      { name: '西安市', adcode: '610100', citycode: '029', city_code: 'xa' },
      { name: '铜川市', adcode: '610200', citycode: '0919', city_code: 'tc' },
      { name: '宝鸡市', adcode: '610300', citycode: '0917', city_code: 'bj' },
      { name: '咸阳市', adcode: '610400', citycode: '0910', city_code: 'xy' },
      { name: '渭南市', adcode: '610500', citycode: '0913', city_code: 'wn' },
      { name: '延安市', adcode: '610600', citycode: '0911', city_code: 'ya' },
      { name: '汉中市', adcode: '610700', citycode: '0916', city_code: 'hz' },
      { name: '榆林市', adcode: '610800', citycode: '0912', city_code: 'yl' },
      { name: '安康市', adcode: '610900', citycode: '0915', city_code: 'ak' },
      { name: '商洛市', adcode: '611000', citycode: '0914', city_code: 'sl' },
      { name: '兰州市', adcode: '620100', citycode: '0931', city_code: 'lz' },
      { name: '嘉峪关市', adcode: '620200', citycode: '1937', city_code: 'jyg' },
      { name: '金昌市', adcode: '620300', citycode: '0935', city_code: 'jc' },
      { name: '白银市', adcode: '620400', citycode: '0943', city_code: 'by' },
      { name: '天水市', adcode: '620500', citycode: '0938', city_code: 'ts' },
      { name: '武威市', adcode: '620600', citycode: '1935', city_code: 'ww' },
      { name: '张掖市', adcode: '620700', citycode: '0936', city_code: 'zy' },
      { name: '平凉市', adcode: '620800', citycode: '0933', city_code: 'pl' },
      { name: '酒泉市', adcode: '620900', citycode: '0937', city_code: 'jq' },
      { name: '庆阳市', adcode: '621000', citycode: '0934', city_code: 'qy' },
      { name: '定西市', adcode: '621100', citycode: '0932', city_code: 'dx' },
      { name: '陇南市', adcode: '621200', citycode: '2935', city_code: 'ln' },
      { name: '临夏回族自治州', adcode: '622900', citycode: '0930', city_code: 'lx' },
      { name: '甘南藏族自治州', adcode: '623000', citycode: '0941', city_code: 'gn' },
      { name: '西宁市', adcode: '630100', citycode: '0971', city_code: 'xn' },
      { name: '海东市', adcode: '630200', citycode: '0972', city_code: 'hd' },
      { name: '海北藏族自治州', adcode: '632200', citycode: '0970', city_code: 'hb' },
      { name: '黄南藏族自治州', adcode: '632300', citycode: '0973', city_code: 'hn' },
      { name: '海南藏族自治州', adcode: '632500', citycode: '0974', city_code: 'hn' },
      { name: '果洛藏族自治州', adcode: '632600', citycode: '0975', city_code: 'gl' },
      { name: '玉树藏族自治州', adcode: '632700', citycode: '0976', city_code: 'ys' },
      { name: '海西蒙古族藏族自治州', adcode: '632800', citycode: '0977', city_code: 'hx' },
      { name: '银川市', adcode: '640100', citycode: '0951', city_code: 'yc' },
      { name: '石嘴山市', adcode: '640200', citycode: '0952', city_code: 'szs' },
      { name: '吴忠市', adcode: '640300', citycode: '0953', city_code: 'wz' },
      { name: '固原市', adcode: '640400', citycode: '0954', city_code: 'gy' },
      { name: '中卫市', adcode: '640500', citycode: '1953', city_code: 'zw' },
      { name: '乌鲁木齐市', adcode: '650100', citycode: '0991', city_code: 'wlmq' },
      { name: '克拉玛依市', adcode: '650200', citycode: '0990', city_code: 'klmy' },
      { name: '吐鲁番市', adcode: '650400', citycode: '0995', city_code: 'tlf' },
      { name: '哈密市', adcode: '650500', citycode: '0902', city_code: 'hm' },
      { name: '昌吉回族自治州', adcode: '652300', citycode: '0994', city_code: 'cj' },
      { name: '博尔塔拉蒙古自治州', adcode: '652700', citycode: '0909', city_code: 'betl' },
      { name: '巴音郭楞蒙古自治州', adcode: '652800', citycode: '0996', city_code: 'bygl' },
      { name: '阿克苏地区', adcode: '652900', citycode: '0997', city_code: 'aks' },
      { name: '克孜勒苏柯尔克孜自治州', adcode: '653000', citycode: '0908', city_code: 'kzlskrkz' },
      { name: '喀什地区', adcode: '653100', citycode: '0998', city_code: 'ks' },
      { name: '和田地区', adcode: '653200', citycode: '0903', city_code: 'ht' },
      { name: '伊犁哈萨克自治州', adcode: '654000', citycode: '0999', city_code: 'yl' },
      { name: '塔城地区', adcode: '654200', citycode: '0901', city_code: 'tc' },
      { name: '阿勒泰地区', adcode: '654300', citycode: '0906', city_code: 'alt' },
      { name: '石河子市', adcode: '659001', citycode: '0993', city_code: 'shz' },
      { name: '阿拉尔市', adcode: '659002', citycode: '1997', city_code: 'ale' },
      { name: '图木舒克市', adcode: '659003', citycode: '1998', city_code: 'tmsk' },
      { name: '五家渠市', adcode: '659004', citycode: '1994', city_code: 'wjq' },
      { name: '北屯市', adcode: '659005', citycode: '1906', city_code: 'bt' },
      { name: '铁门关市', adcode: '659006', citycode: '1996', city_code: 'tmg' },
      { name: '双河市', adcode: '659007', citycode: '1909', city_code: 'sh' },
      { name: '可克达拉市', adcode: '659008', citycode: '1999', city_code: 'kkdl' },
      { name: '昆玉市', adcode: '659009', citycode: '1903', city_code: 'ky' },
      { name: '胡杨河市', adcode: '659010', citycode: '0992', city_code: 'hyh' },
      { name: '新星市', adcode: '659011', citycode: '2940', city_code: 'xx' },
      { name: '白杨市', adcode: '659012', citycode: '2941', city_code: 'by' },
      { name: '台湾省', adcode: '710000', citycode: '1886', city_code: 'tw' },
      { name: '香港特别行政区', adcode: '810000', citycode: '1852', city_code: 'hk' },
      { name: '澳门特别行政区', adcode: '820000', citycode: '1853', city_code: 'mo' }
    ]
